import type { TimelineRequest } from "../../lib/types";

export type LoopRun = {
  start: number;
  length: number;
  tools: string;
  cost: number;
};

const MIN_RUN = 10;

const signature = (r: TimelineRequest): string =>
  r.tools
    .map((t) => `${t.tool}${t.calls > 1 ? ` ×${t.calls}` : ""}`)
    .sort()
    .join(", ");

/** The longest run of back-to-back turns that called exactly the same tools;
 * long enough, it is an agent going round in circles. */
export function findLoop(requests: TimelineRequest[]): LoopRun | null {
  let best: LoopRun | null = null;
  let i = 0;
  while (i < requests.length) {
    const sig = signature(requests[i]);
    let j = i + 1;
    while (j < requests.length && signature(requests[j]) === sig) j++;
    if (sig && j - i >= MIN_RUN && (!best || j - i > best.length)) {
      const cost = requests
        .slice(i, j)
        .reduce((s, r) => s + Number(r.cost_usd ?? 0), 0);
      best = { start: i, length: j - i, tools: sig, cost };
    }
    i = j;
  }
  return best;
}
